import { getUniqueKey } from '../../utils/NumberUtils';

export const SHOWN_TOOLTIP_ACTION = 'SHOWN_TOOLTIP_ACTION';
export const HIDDEN_TOOLTIP_ACTION = 'HIDDEN_TOOLTIP_ACTION';

export const ENTER_TOOLTIP_ACTION = 'ENTER_TOOLTIP_ACTION';
export const LEAVE_TOOLTIP_ACTION = 'LEAVE_TOOLTIP_ACTION';

export const openTolltip = (text, rect, key, option = {}) => {
  const payload = {
    text,
    key: key || getUniqueKey(),
    rect: rect,
    opened: true,
    options: option || {},
  };
  return {
    type: SHOWN_TOOLTIP_ACTION,
    payload,
  };
};

export const closeTolltip = (key) => {
  return (dispatch) => {
    dispatch({
      type: HIDDEN_TOOLTIP_ACTION,
      payload: key,
    });
  };
};

export const enterTooltip = (key) => {
  return (dispatch) => {
    dispatch({
      type: ENTER_TOOLTIP_ACTION,
      payload: key,
    });
  };
};

export const leaveTooltip = (key) => {
  return (dispatch) => {
    dispatch({
      type: LEAVE_TOOLTIP_ACTION,
      payload: key,
    });
  };
};
